import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitCamelCase'
})
export class SplitCamelCasePipe implements PipeTransform {

  transform(value: string | undefined): string {
    return value ? value.replace(/([a-z])([A-Z])/g, '$1 $2') : '';
  }

}
